import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useHistory } from "react-router-dom";
import { PollApiCalls } from "../../apis/PollApiCalls";
import {
    ACTION_TEXT,
    ACTIVITY_TITLE_TEXT, DRAFT_ACTIVITIES_DESCRIPTION, DRAFT_ACTIVITIES_TEXT, DRAFT_NOT_EMBEDDED_TEXT,
    DRAFT_STATUS, EDIT_TEXT,
    NO_RECENT_ACTIVITIES, NO_RECENT_ACTIVITIES_DESCRIPTION,
    POLL_SHARE_MODE, POLL_STATUS_HEADER, READY_TO_SHARE, RELEASE_TEXT,
    TEXTBOX,
    USER_SETTINGS
} from "../../utils/constants";
import {getPollStatus, notifyError, removePrefix, removePrefixNew} from "../../utils/helpers";
import {RELEASE_INVALID_POLL_ERROR} from "../../utils/toast-message-constants";
import styles from "./DashboardPage.module.css";
import { ReactComponent as ModifiedPollIcon } from "./images/gradient_history_icon.svg";
import { ReactComponent as NoResultIllustration } from "../../images/no_result.svg";
import {Table} from "react-bootstrap";
import {Button} from "@base-ui/react/button";

export default function DashboardCardDraftActivities({data=[], courseOptions=[], loading=true, userSettings={}}) {
    const { publishPoll} = PollApiCalls();
    const history = useHistory();


    const release = async (poll) => {
        poll.pollKey = removePrefix(poll.pollKey);
        if (poll.pollSortKey !== DRAFT_STATUS) {
            history.push(`/poll/share/${poll.pollKey}/${removePrefixNew(poll.pollSortKey)}`);
            return;
        }
        poll.pollShareMode = POLL_SHARE_MODE.UNKNOWN;
        if (!poll.pollTimeLimit) poll.pollTimeLimit = userSettings[USER_SETTINGS.POLL_DURATION];
        // if (!poll.getReadyAllTimeLimit) poll.getReadyAllTimeLimit = userSettings[USER_SETTINGS.POLL_COUNTDOWN];
        if (!poll.lmsAttempt) poll.lmsAttempt = userSettings[USER_SETTINGS.POLL_LMS_SYNC];
        if (!poll.recordAttempt) poll.recordAttempt = userSettings[USER_SETTINGS.POLL_RECORD_ATTEMPTS];
        if (!poll.maxAttempts) poll.maxAttempts = userSettings[USER_SETTINGS.POLL_MAX_ATTEMPTS];
        let questions = poll.questions;
        for (let i = 0; i < questions.length; i++) {
            if (!questions[i].weightage) questions[i].weightage = userSettings[USER_SETTINGS.QUESTION_POINTS];
            if (!questions[i].timeLimit) questions[i].timeLimit = userSettings[USER_SETTINGS.QUESTION_DURATION];
            if (!questions[i].getReadyTimeLimit) questions[i].getReadyTimeLimit = userSettings[USER_SETTINGS.QUESTION_COUNTDOWN];
        }
        poll.questions = questions;
        let result = await publishPoll(poll, true);

        if (!result || !result.uniqueCode) {
            notifyError(RELEASE_INVALID_POLL_ERROR);
            return;
        }
        const {draft={}, uniqueCode} = result;
        history.push(`/poll/share/${removePrefix(draft.pollKey)}/${uniqueCode}`);
    };


    const edit = (poll) => {
        history.push(`/edit/${removePrefix(poll.pollKey)}/${DRAFT_STATUS}`);
    }

    const viewResult = (poll, status) => {
        if (status === READY_TO_SHARE || status === DRAFT_NOT_EMBEDDED_TEXT) {
            release(poll);
        } else {
            edit(poll)
        }

    }

    if (loading) {
        return (
            <div style={{ flex: 1, height: 350}}>
                <Skeleton borderRadius={10} height={"100%"} width={"100%"}/>
            </div>
        );
    }


    return (
        <div className={styles.panelContainer} style={{display: "flex", flexDirection: "column", flex: 1}}>
            <div className={styles.panelTitle}>
                <ModifiedPollIcon style={{marginRight: "15px", flexShrink: 0, width: 18, height: 18}}/>
                <div role={TEXTBOX}>{DRAFT_ACTIVITIES_TEXT}</div>
            </div>
            <div className={styles.panelBody}>
                {/* {courseModalShow && <FormModal
                    show={courseModalShow}
                    setModalShow={setCourseModalShow}
                    modalConfig={modalConfig}
                    pollTimeLimit={pollTimeLimit}
                    setPollTimeLimit={setPollTimeLimit}
                    setShareAll={setShareAll}
                    shareAll={shareAll}
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                />} */}
                {(!data || !data.length) &&
                    <>
                        <div style={{flex: 1}}/>
                        <NoResultIllustration style={{maxWidth: "100%", maxHeight: "100%", marginRight: "15px"}}/>
                        <span className={styles.noResultTitle} style={{marginTop: 40}}>
                            {NO_RECENT_ACTIVITIES}
                        </span>
                        <span className={styles.noResultDescription} >
                            {NO_RECENT_ACTIVITIES_DESCRIPTION}
                        </span>
                        <div style={{flex: 1}}/>
                    </>
                }
                {(!!data && !!data.length) &&
                    <>
                        <div className={styles.panelDescription} style={{alignSelf: "start"}}>
                            {DRAFT_ACTIVITIES_DESCRIPTION}
                        </div>
                        <div className={styles.tableWrapper}>
                            <Table className={styles.recentResultTable} hover>
                                <thead >
                                    <tr>
                                        <th style={{width: 200, minWidth: 0, textAlign: "left"}}>
                                            {ACTIVITY_TITLE_TEXT}
                                        </th>
                                        <th style={{width: 190, minWidth: 0}}>{POLL_STATUS_HEADER}</th>
                                        <th style={{width: 120, minWidth: 0,}}>{ACTION_TEXT}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {JSON.parse(JSON.stringify(data)).splice(0, 5).map((poll, index) => {
                                    const status = getPollStatus(poll);
                                    return (
                                        <tr  key={index} style={{cursor: "pointer"}} onClick={() => viewResult(poll, status)}>
                                            <td className={styles.omitableText}
                                                style={{textAlign: "left"}}>{poll.pollTitle}</td>
                                            <td>
                                                <div style={{display: "flex"}}>
                                                    <span
                                                        style={{width: 180}}
                                                        className={`
                                                            ${styles.badge} 
                                                            ${status === READY_TO_SHARE ? styles.completed : styles.inCompleted}
                                                        `}
                                                    >
                                                       {status}
                                                    </span>
                                                </div>

                                            </td>

                                            <td>
                                                <div style={{display: "flex"}}>
                                                    <Button
                                                        className={styles.gradientButton}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            viewResult(poll, status);
                                                        }}
                                                    >
                                                        {(status === READY_TO_SHARE || status === DRAFT_NOT_EMBEDDED_TEXT)
                                                            ? RELEASE_TEXT : EDIT_TEXT}
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </div>
                    </>


                }
            </div>
        </div>
    );
}